/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { createStore, applyMiddleware, compose } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { routerMiddleware, connectRouter } from 'connected-react-router'
import createSagaMiddleware from 'redux-saga'

import { createBrowserHistory } from 'history'
// import { Iterable } from 'immutable'

import throttle from './middleware/throttle'
import api from '../api/middleware'
import app from '../containers/App/middleware'
import nav from '../containers/Nav/middleware'
import schedule from '../containers/Schedule/middleware'
import phone from '../containers/Phone/middleware'

import { setApiError } from '../api/actions'
import rootReducer from './reducer'
import rootSagas from './sagas'

const sagaMiddleware = createSagaMiddleware()

export const history = createBrowserHistory()

const middlewares = [
  routerMiddleware(history),
  sagaMiddleware,
  throttle,
  schedule,
  api,
  app,
  nav,
  phone
]

// if (!IS_PRODUCTION) middlewares.push(storeLogger)

const store = createStore(rootReducer, applyMiddleware(...middlewares))
export const { dispatch } = store

sagaMiddleware.run(rootSagas)

export default store
